document.addEventListener("DOMContentLoaded", function(event) {

    const container = document.querySelector('[data-index-estates-columns]');
    if (!container) return;

    const leftCol   = container.querySelector('[data-index-estates-column="1"]');
    const centerCol = container.querySelector('[data-index-estates-column="2"]');
    const rightCol  = container.querySelector('[data-index-estates-column="3"]');
    if (!leftCol || !centerCol || !rightCol) {
        console.warn('Některý ze sloupců index-estates-column neexistuje.');
        return;
    }

    const scrollspeed = 2;
    const visibleHeight = 500;

    //let ticking = false;
    let active = false;
    let leftHeight;
    let rightHeight;
    let maxScroll;
    let scroll;
    let startY;

    function enableScrollingEffect() {
        if (active) return;
        active = true;

        leftHeight = visibleHeight - leftCol.scrollHeight;
        rightHeight = visibleHeight - rightCol.scrollHeight;
        maxScroll = centerCol.scrollHeight - visibleHeight;
        setInitialPositions();

        container.addEventListener('scroll', onScroll);
        container.addEventListener('wheel', handleWheel, { passive: false });
        container.addEventListener('touchstart', handleTouchStart, { passive: true });
        container.addEventListener('touchmove', handleTouchMove, { passive: false });
        onScroll();
    }
    function disableScrollingEffect() {
        if (!active) return;
        active = false;
        container.removeEventListener('scroll', onScroll);
        container.removeEventListener('wheel', handleWheel);
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        leftCol.style.transform = '';
        rightCol.style.transform = '';
    }

    function onScroll() {
        if (!active) return;
        scroll = container.scrollTop;

        // zabrání dojetí za konec skrolování
        if (scroll >= maxScroll) {
            container.scrollTop = maxScroll;
        } else {
            window.requestAnimationFrame(() => {
                updateColumns(scroll);
            });
        }
    }

    function setInitialPositions() {
        leftCol.style.transform = `translateY(${leftHeight}px)`;
        rightCol.style.transform = `translateY(${rightHeight}px)`;
        centerCol.style.transform = `translateY(30px)`;
    }

    function updateColumns(scroll) {
        // levý/pravý vyjíždí zdola nahoru
        leftCol.style.transform  = `translateY(${leftHeight + scroll * scrollspeed}px)`;
        rightCol.style.transform = `translateY(${rightHeight + scroll * scrollspeed}px)`;
    }

    // blokování scrollu dolů u maxScroll
    function handleWheel(e) {
        if (container.scrollTop >= maxScroll && e.deltaY > 0) {
            const delta = e.deltaY;
            window.scrollBy({ top: delta, behavior: 'auto' });
            e.preventDefault(); // zabrání scrollu dolů
        }
    }

    function handleTouchStart(e) {
        startY = e.touches[0].clientY;
    }

    function handleTouchMove(e) {
        let deltaY = startY - e.touches[0].clientY;
        if (container.scrollTop >= maxScroll && deltaY > 0) {
            window.scrollBy({ top: deltaY, behavior: 'auto' });
            e.preventDefault(); // zabrání scrollu dolů
        }
    }

    function checkViewport() {
        if (window.innerWidth > 768) {
            enableScrollingEffect();
        } else {
            disableScrollingEffect();
        }
    }

    window.addEventListener('load', checkViewport);
    window.addEventListener('resize', checkViewport);
    window.addEventListener('orientationchange', checkViewport);

});
